import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('@/views/login'),
    meta: {
      title: 'BENDA DMS'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login'),
    meta: {
      title: 'BENDA DMS'
    }
  },
  {
    path: '/index',
    component: () => import('@/views/index'),
    meta: {
      title: 'BENDA DMS'
    },
    children: [
      {
        path: '/zx',
        component: () => import('@/views/zx'),
        meta: {
          title: 'BENDA DMS'
        },
      },
       {
        path: '/Sales',
        component: () => import('@/views/index/xs'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/sell',
        component: () => import('@/views/sell'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      
       {
        //质保列表
        path: '/Guarantee',
        component: () => import('@/views/Guarantee'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        //质保申请
        path: '/Guaranteeup',
        component: () => import('@/views/Guarantee/up'),
        meta: {
          title: 'BENDA DMS'
        },
      },
       {
        //质保详情
        path: '/Guaranteedetails',
        component: () => import('@/views/Guarantee/cont'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      
      {
        //车辆库存 进销商
        path: '/Inventory',
        component: () => import('@/views/vehicle/Inventory'),
        meta: {
          title: 'BENDA DMS'
        },
      },
       {
        //车辆库存 零售商
        path: '/Inventorya',
        component: () => import('@/views/vehicle/Inventorya'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        //维保登记
        path: '/Maintenance',
        component: () => import('@/views/Maintenance'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        //创建维保单
        path: '/Maintenanceup',
        component: () => import('@/views/Maintenance/up'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        //维保单详情
        path: '/Maintenancecontent',
        component: () => import('@/views/Maintenance/content'),
        meta: {
          title: 'BENDA DMS'
        },
      },
        {
          //销售注册
        path: '/sellup',
        component: () => import('@/views/sell/up'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
          //车辆档案
        path: '/Archives',
        component: () => import('@/views/sell/Archives'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      
      {
        path: '/sellcontent',
        component: () => import('@/views/sell/content'),
        meta: {
          title: 'BENDA DMS'
        },
      },
       {
        path: '/archcont',
        component: () => import('@/views/sell/archcont'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      
      {
        path: '/documents',
        component: () => import('@/views/document'),
        meta: {
          title: 'BENDA DMS',
         
        },
      },
       {
        path: '/PublishDocuments',
        component: () => import('@/views/document/updata'),
        meta: {
          title: 'BENDA DMS',
         
        },
      },
      {
        path: '/order',
        component: () => import('@/views/order'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      // 发票管理
      {
        path: '/Invoice',
        component: () => import('@/views/Invoice'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      
      //零售商的采购单
       {
        path: '/ordera',
        component: () => import('@/views/order/indexa'),
        meta: {
          title: 'BENDA DMS'
        },
      },
       //零售商的发货单
       {
        path: '/DeliveryNote',
        component: () => import('@/views/order/fhd'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/ordercontent',
        component: () => import('@/views/order/content'),
        meta: {
          title: 'BENDA DMS'
        },
      },
        {
        path: '/ordercontenta',
        component: () => import('@/views/order/contenta'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/orderDetails',
        component: () => import('@/views/order/details'),
        meta: {
          title: 'BENDA DMS'
        },
      },
       {
        path: '/orderDetailsa',
        component: () => import('@/views/order/detailsa'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/ClaimPartsOrder',
        component: () => import('@/views/shop/ksshop'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/account',
        component: () => import('@/views/account'),
        meta: {
          title: 'BENDA DMS'
        },
      },
       {
        path: '/FlowingWater',
        component: () => import('@/views/account/FlowingWater'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      
      {
        path: '/my',
        component: () => import('@/views/my'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/employee',
        component: () => import('@/views/my/employee'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/Claim',
        component: () => import('@/views/sale/order'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/ClaimOrder',
        component: () => import('@/views/sale/order'),
        meta: {
          title: 'BENDA DMS'
        },
      },
       {
        path: '/ClaimOrdera',
        component: () => import('@/views/sale/ordera'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/Compensation',
        component: () => import('@/views/sale/pfqd'),
        meta: {
          title: 'BENDA DMS'
        },
      },
       {
        path: '/Compensationpo',
        component: () => import('@/views/sale/pfqd2'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/ClaimHour',
        component: () => import('@/views/sale/hour'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/ClaimApply',
        component: () => import('@/views/sale/addclaim'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/ClaimApplyb',
        component: () => import('@/views/sale/addclaimb'),
        meta: {
          title: 'BENDA DMS'
        },
      },
       {
        path: '/ClaimApplyc',
        component: () => import('@/views/sale/addclaimc'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/ClaimApplyac',
        component: () => import('@/views/sale/addclaimaa'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/Shipment',
        component: () => import('@/views/sale/fhd'),
        meta: {
          title: 'BENDA DMS'
        },
      },
       {
        path: '/myShipment',
        component: () => import('@/views/sale/myfhd'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/ClaimApplya',
        component: () => import('@/views/sale/addclaima'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/shop',
        component: () => import('@/views/shop'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {//销售 零售商管理
        path: '/Retailer',
        component: () => import('@/views/Sales/Retailer'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {//销售配件管理
        path: '/Accessories',
        component: () => import('@/views/Sales/Accessories'),
        meta: {
          title: 'BENDA DMS'
        },
      },
       {//配件管理
        path: '/Access',
        component: () => import('@/views/Sales/Access'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {//销售车型管理
        path: '/Carprice',
        component: () => import('@/views/Sales/Carprice'),
        meta: {
          title: 'BENDA DMS'
        },
      },
       {//销售尾单 采购
        path: '/Tailorder',
        component: () => import('@/views/Sales/updont'),
        meta: {
          title: 'BENDA DMS'
        },
      },
       {//销售尾单 销售 
        path: '/Tailordera',
        component: () => import('@/views/Sales/updonta'),
        meta: {
          title: 'BENDA DMS'
        },
      },
        {//发货单
        path: '/Deliverynotea',
        component: () => import('@/views/Sales/Deliverynote'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/sale',
        component: () => import('@/views/sale'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/public',
        component: () => import('@/views/publicnotice'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/PublishPublic',
        component: () => import('@/views/publicnotice/updata'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      
      {
        path: '/attachment',
        component: () => import('@/views/shop/attachment'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/attachments',
        component: () => import('@/views/shop/attachments'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/cart',
        component: () => import('@/views/shop/cart'),
        meta: {
          title: 'BENDA DMS'
        },
      },
        {
        path: '/carta',
        component: () => import('@/views/shop/carta'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      {
        path: '/Vehicle_Purchase',
        component: () => import('@/views/shop/Vehicle_Purchase'),
        meta: {
          title: 'BENDA DMS'
        },
      },
      
      {
        path: '/start',
        component: () => import('@/views/start/index'),
        meta: {
          title: 'BENDA DMS'
        },
      },


    ]
  },

  {
    path: '*',
    component: () => import('@/views/404.vue'),
    // redirect:'/404'
  },
]



const router = new VueRouter({
  mode:'history',
  routes
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  //1.如果用户访问/login的请求,应该直接放行
  if (to.path === '/login') return next()

  //2.不是访问的登录页面,所以判断用户是否登录. 判断依据token
  let token = window.sessionStorage.getItem("token")

  //3.如果!token  没有值,则执行if之后的操作
  if (!token) return next("/login")

  //4.如果代码执行到这一行,说明用户已经登录.则放行
  next()
})

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)

}
// router.beforeEach((to, from, next) => {
//   let token = window.sessionStorage.getItem('token')
//   if (token ) {
//     next()
//   }else {
//     if (to.path == '/login' ) {
//       next()
//     } else {
//       next('/login')
//     }
//   }

// });


export default router
